import fetch from 'node-fetch';
import { isLLc } from './utils';
import { PAYPAL_INIT, SIGN_IN } from '../constants/constants';
import { logAnalytics, getAnalyticsEventName } from './AnalyticsHelper';

export const generateInitUrl = (orderId, fromPage, itemCount, ffm) => {
  const urlDomain = !isLLc() ? 'https://www.homedepot.com' : 'https://hd-qa74.homedepotdev.com';
  // mcc-checkout will set paypal express as true if fromPage is shoppingCart or addToCart
  // for any other values it will be set as false.
  const urlParams = '?fromPage=' + fromPage
    + '&orderId=' + orderId
    + '&itemType=' + ffm
    + '&itemCount=' + itemCount
    // These dont seem to do anything in mcc-checkout
    + '&myCart=true&opc=true';
  return urlDomain + PAYPAL_INIT + urlParams;
};

export const fetchPaypalToken = (orderId, fromPage, itemCount, ffm) => {
  let fromPageParam = fromPage === 'pip' ? 'shoppingCart' : fromPage;
  const options = {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'include',
  };

  const req = new fetch.Request(generateInitUrl(orderId, fromPageParam, itemCount, ffm), options);
  return req;
};

export const onApprove = (paypalData, orderId) => {
  try {
    const payPalReviewUrl = '/mycheckout/checkout?orderId=' + orderId
      + '&navigation=expressPaypal&token=' + paypalData?.orderID
      + '&PayerID=' + paypalData?.payerID;
    window.top.location.href = payPalReviewUrl;
  } catch (error) {
    console.log('Paypal on approve error: ' + error);
  }
};

export const createOrder = (cartId, orderId, hasSavedPaypal, payInFour, fromPage, itemCount, ffm) => {
  const eventName = getAnalyticsEventName(hasSavedPaypal, payInFour, fromPage);
  logAnalytics({ eventName });
  return fetch(fetchPaypalToken(typeof cartId === 'string' ? cartId : orderId, fromPage, itemCount, ffm))
    .then((response) => response.json())
    .then((response) => {
      if (response?.checkoutModel?.paypalModel) {
        return response.checkoutModel.paypalModel.token;
      }
      if (response?.checkoutModel?.authRedirectErrorModel?.errorDescription === 'Session Expired') {
        window.top.location = window?.location?.origin + '/' + SIGN_IN + '?pp_persisted=true';
      }
      return null;
    }).catch((error) => {
      console.log('Paypal create order error: ' + error);
    });
};
